import React, { useEffect, useState } from 'react';
import { useMyContext } from '../../../context/MyContext';
import NavBar from '../../../component/b2c/navBar/navBar';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import { FiDownload } from "react-icons/fi";
import { Base_Url, ratecsvuplode, fetchUser, ratecardList } from '../../../config/config'
import { toast } from 'react-toastify';
import { Upload, X, Eye } from 'lucide-react';
import { FileText, Sparkles, CheckCircle } from 'lucide-react';
import axios from 'axios';
import '../../../css/custom-scrollbar.css';
import Select from "react-dropdown-select";
import Papa from "papaparse";
import { useNavigate } from 'react-router-dom';

export default function SetRate() {
  
  const [file, setFile] = useState(null);
  const [Id, setId] = useState('')
  const [weight, setWeight] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [previewData, setPreviewData] = useState(null);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const navigate = useNavigate()

  const weightOptions = [
    { value: '200g', label: '200g' },
    { value: '500g', label: '500g' },
    { value: '1kg', label: '1kg' },
    { value: '5kg', label: '5kg' },
    { value: '10kg', label: '10kg' },
  ];

  useEffect(() => {
    fetchCustomers();
  }, [])

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    setFile(uploadedFile);
    setUploadSuccess(false);

    // Parse CSV for preview
    Papa.parse(uploadedFile, {
      complete: (results) => {
        setPreviewData(results.data);
      },
      header: true,
      skipEmptyLines: true,
    });
  };


  const handleUpload = async (event) => {
    event.preventDefault();
    if (!Id) {
      toast.error('Please select a seller first.');
      return;
    }
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    setIsUploading(true);
    if (file) {
      const formData = new FormData();
      formData.append('csv_file', file);
      formData.append('seller_id', Id)
      try {
        const response = await axios.post(Base_Url + "admin/" + ratecsvuplode, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'token': token,
            'cus_id': cus_id,
          },
        });
        setFile(null);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          setIsUploading(false);
          setUploadSuccess(true);
          setTimeout(() => {
            navigate("/dasboard");
          }, 1000)
        }
        else if (response.data.status === "success") {
          toast.error(response.data.message + response.data.message);
        }
        else {
          toast.error(response.data.message + response.data.message);
          setIsUploading(false);
        }
      } catch (error) {
        setIsUploading(false);
      }
    }
  };

  const fetchRateCardList = async (selectedId) => {
    try {
      const url = Base_Url + ratecardList + "/" + selectedId;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token || '',
          cus_id: cus_id || '',
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch data');
      }

      const result = await response.json();

      if (result && result.data) {
        return result.data;
      } else {
        console.error('Unexpected response structure:', result);
        throw new Error('Unexpected response structure');
      }
    } catch (error) {
      console.error('API error:', error.message);
      toast.error('Error fetching rate card data: ' + error.message);
      throw error;
    }
  };

  const handleDownloadRateCard = async () => {
    if (!Id) {
      toast.error('Please select an ID first.');
      return;
    }

    setIsDownloading(true);
    try {
      const rateCardData = await fetchRateCardList(Id);

      if (rateCardData && rateCardData.length > 0) {
        // Convert data to CSV format
        const csvContent = Papa.unparse(rateCardData, {
          header: true,
          columns: [
            'zone_name',
            'surface_price',
            'additional_surfaceprice_per500gm',
            'express_price',
            'additional_expressprice_per500gm',
            'partner',
            'min_cod_price',
            'cod_percentage'
          ]
        });

        // Create and download CSV file
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `ratecard_${Id}_${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast.success('Rate card downloaded successfully!');
      } else {
        toast.error('No rate card data found for this ID.');
      }
    } catch (error) {
      toast.error('Failed to download rate card: ' + error.message);
    } finally {
      setIsDownloading(false);
    }
  };

  const openPreviewModal = () => {
    setIsPreviewModalOpen(true);
  };
  const closePreviewModal = () => {
    setIsPreviewModalOpen(false);
  };

  const fetchCustomers = async () => {
    const url = Base_Url + fetchUser;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "success") {
        const transformedData = data.data.map(user => {
          const capitalizedName = user.name.charAt(0).toUpperCase() + user.name.slice(1);
          return {
            value: user.id,
            label: `${capitalizedName} (${user.id})`,
          };
        });
        setCustomers(transformedData);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  }
  const handleSelectChange = (selected) => {
    if (selected.length > 0) {
      const selectedItem = selected[0];
      setId(selectedItem.value);
    }
  };

  const handleWeightChange = (selected) => {
    if (selected.length > 0) {
      const selectedItem = selected[0];
      setWeight(selectedItem.value);
    }
  };

  const selectControlStyles = (base) => ({
    ...base,
    padding: '2px',
    background: isDarkMode ? '#000000' : '#ffffff',
    border: `1px solid ${isDarkMode ? '#ffffff' : '#000000'}`,
    borderRadius: '8px',
    fontSize: '12px',
    fontWeight: '500',
    boxShadow: 'none',
  });

  const selectOptionStyles = (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? isDarkMode ? '#ffffff' : '#000000'
      : state.isFocused
        ? isDarkMode ? '#1f1f1f' : '#f3f4f6'
        : 'transparent',
    color: state.isSelected
      ? isDarkMode ? '#000000' : '#ffffff'
      : isDarkMode ? 'white' : '#1e293b'
  });

  const PreviewModal = () => {
    if (!previewData || previewData.length === 0) return null;

    // Get column headers
    const headers = Object.keys(previewData[0]);

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 overflow-y-auto p-4">
        <div className="bg-white dark:bg-black rounded-xl shadow-2xl w-11/12 max-w-6xl max-h-[90vh] overflow-hidden border border-black dark:border-white">

          {/* Header */}
          <div className="flex justify-between items-center p-4 border-b border-black dark:border-white bg-black dark:bg-white">
            <div className="flex items-center space-x-3">
              <div className="p-1.5 bg-white/10 dark:bg-black/10 rounded-full">
                <FileText className="w-5 h-5 text-white dark:text-black" />
              </div>
              <div>
                <h2 className="text-base font-bold text-white dark:text-black">
                  Data Preview
                </h2>
                <p className="text-gray-300 dark:text-gray-700 text-xs">Review your uploaded data</p>
              </div>
            </div>
            <button
              onClick={closePreviewModal}
              className="p-1.5 bg-white/10 hover:bg-white/20 dark:bg-black/10 dark:hover:bg-black/20 rounded-full transition-colors duration-200 text-white dark:text-black"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          {/* Content Area */}
          <div className="overflow-auto max-h-[70vh] p-3 custom-scrollbar bg-white dark:bg-black">

            {/* Data Stats */}
            <div className="mb-3 bg-gray-50 dark:bg-gray-900 rounded-lg p-3 border border-gray-300 dark:border-gray-700">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="p-1.5 bg-black dark:bg-white rounded-full">
                    <FileText className="w-3.5 h-3.5 text-white dark:text-black" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-black dark:text-white text-xs">Data Summary</h3>
                    <p className="text-xs text-gray-600 dark:text-gray-400">
                      Total Records: <span className="font-bold text-black dark:text-white">{previewData.length}</span> |
                      Columns: <span className="font-bold text-black dark:text-white">{headers.length}</span>
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-xs text-gray-500 dark:text-gray-400">Showing first 50 rows</p>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="rounded-lg overflow-hidden border border-gray-300 dark:border-gray-700">
              <div className="overflow-x-auto custom-scrollbar">
                <table className="w-full">

                  <thead className="sticky top-0 bg-black dark:bg-white">
                    <tr>
                      {headers.map((header, index) => (
                        <th
                          key={index}
                          className="p-2.5 text-left font-semibold text-white dark:text-black text-[11px] uppercase tracking-wide border-r border-white/20 dark:border-black/20 last:border-r-0"
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {previewData.slice(0, 50).map((row, rowIndex) => (
                      <tr
                        key={rowIndex}
                        className={`${rowIndex % 2 === 0
                          ? 'bg-gray-50 dark:bg-gray-900'
                          : 'bg-white dark:bg-black'
                          } hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors duration-150`}
                      >
                        {headers.map((header, colIndex) => (
                          <td
                            key={colIndex}
                            className="p-2.5 text-xs text-black dark:text-white border-r border-gray-200 dark:border-gray-800 last:border-r-0"
                          >
                            <div className="truncate max-w-xs" title={row[header]}>
                              {row[header]}
                            </div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";
  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-white'}`}>
      {isPreviewModalOpen && <PreviewModal />}


            <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />
      
              <NavBar />
              <div className="flex flex-1 overflow-hidden">
                {isToggleSidebar && (
                  <div className={`w-64 m-3 rounded-3xl ${glass} overflow-hidden`}>
                    <Sidebar />
                  </div>
                )}

        {/* Page body: fixed, absolutely no page-level scroll */}
        <div className=" flex flex-1 flex-col overflow-hidden bg-gray-200 w-full dark:bg-black  p-2 md:p-3">
          <div className="w-full  max-h-full">
            <div className="bg-white dark:bg-black border border-gray-200 dark:border-gray-800 rounded-xl overflow-hidden shadow-sm">

              {/* Header */}
              <div className="bg-black dark:bg-white px-4 py-2.5">
                <div className="flex items-center space-x-2">
                  <div className="p-1.5 bg-white/10 dark:bg-black/10 rounded-full">
                    <Upload className="w-3.5 h-3.5 text-white dark:text-black" />
                  </div>
                  <h2 className="text-sm font-bold text-white dark:text-black">
                    Upload Rate Card
                  </h2>
                </div>
              </div>

              {/* Customer + Weight Selection side by side */}
              <div className='px-4 pt-3 grid grid-cols-2 gap-3'>
                <div>
                  <label htmlFor="Id" className="block text-xs font-semibold text-gray-700 dark:text-gray-200 mb-1.5 flex items-center">
                    <span className="w-1.5 h-1.5 bg-black dark:bg-white rounded-full mr-1.5 shrink-0"></span>
                    <span className="truncate">Select Customer ID</span>
                  </label>
                  <Select
                    options={customers}
                    onChange={handleSelectChange}
                    className="w-full"
                    styles={{
                      control: selectControlStyles,
                      option: selectOptionStyles
                    }}
                  />
                </div>

                <div>
                  <label htmlFor="weight" className="block text-xs font-semibold text-gray-700 dark:text-gray-200 mb-1.5 flex items-center">
                    <span className="w-1.5 h-1.5 bg-black dark:bg-white rounded-full mr-1.5 shrink-0"></span>
                    <span className="truncate">Select Weight</span>
                  </label>
                  <Select
                    options={weightOptions}
                    onChange={handleWeightChange}
                    className="w-full"
                    styles={{
                      control: selectControlStyles,
                      option: selectOptionStyles
                    }}
                  />
                </div>
              </div>

              {/* Download Button */}
              <div className="mt-3 px-4">
                <button
                  type="button"
                  onClick={handleDownloadRateCard}
                  disabled={!Id || isDownloading}
                  className={`w-full p-2 rounded-lg font-semibold text-xs transition-colors duration-200 border ${!Id || isDownloading
                    ? 'bg-gray-100 dark:bg-gray-900 cursor-not-allowed text-gray-400 border-gray-300 dark:border-gray-700'
                    : 'bg-white hover:bg-gray-100 text-black border-black dark:bg-black dark:text-white dark:border-white dark:hover:bg-gray-900'
                    }`}
                >
                  <div className="flex items-center justify-center space-x-2">
                    {isDownloading ? (
                      <div className="w-3.5 h-3.5 border-2 border-gray-400 border-t-black dark:border-t-white rounded-full animate-spin"></div>
                    ) : (
                      <FiDownload className="w-3.5 h-3.5" />
                    )}
                    <span>{isDownloading ? 'Downloading...' : 'Download Current Rate Card'}</span>
                  </div>
                </button>
              </div>

              {/* File Upload Section */}
              <div className="p-4">
                <label className="block text-xs font-semibold text-gray-700 dark:text-gray-200 mb-1.5 flex items-center">
                  <span className="w-1.5 h-1.5 bg-black dark:bg-white rounded-full mr-2"></span>
                  Upload Your CSV File
                </label>

                {/* Drag & Drop Zone */}
                <div className="relative border-2 border-dashed border-gray-300 dark:border-gray-700 rounded-xl p-3 transition-colors duration-200 hover:border-black dark:hover:border-white bg-gray-50 dark:bg-gray-900/40 cursor-pointer">
                  <input
                    type="file"
                    accept=".csv"
                    onChange={handleFileChange}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                  />

                  <div className="text-center">
                    <div className="mx-auto w-8 h-8 bg-black dark:bg-white rounded-full flex items-center justify-center mb-1.5">
                      <Upload className="w-4 h-4 text-white dark:text-black" />
                    </div>
                    <p className="text-xs font-semibold text-gray-700 dark:text-gray-200 mb-0.5">
                      Drop your CSV file here or click to browse
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      Supports CSV files up to 10MB
                    </p>

                    {file && (
                      <div className="mt-2 p-1.5 bg-white dark:bg-black rounded-lg border border-black dark:border-white">
                        <div className="flex items-center justify-center space-x-2">
                          <CheckCircle className="w-3.5 h-3.5 text-black dark:text-white" />
                          <span className="font-medium text-xs text-black dark:text-white">{file.name}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col md:flex-row gap-2 mt-3">
                  <button
                    type="button"
                    onClick={handleUpload}
                    disabled={!file || isUploading}
                    className={`flex-1 p-2 rounded-lg font-semibold text-xs transition-colors duration-200 border ${!file || isUploading
                      ? 'bg-gray-100 dark:bg-gray-900 cursor-not-allowed text-gray-400 border-gray-300 dark:border-gray-700'
                      : 'bg-black hover:bg-gray-800 text-white dark:bg-white dark:text-black dark:hover:bg-gray-200 border-black dark:border-white'
                      }`}
                  >
                    <div className="flex items-center justify-center space-x-2">
                      {isUploading ? (
                        <div className="w-3.5 h-3.5 border-2 border-white/30 border-t-white dark:border-black/30 dark:border-t-black rounded-full animate-spin"></div>
                      ) : (
                        <Upload className="w-3.5 h-3.5" />
                      )}
                      <span>{isUploading ? 'Processing...' : 'Upload & Process'}</span>
                    </div>
                  </button>

                  {file && previewData && (
                    <button
                      type="button"
                      onClick={openPreviewModal}
                      className="flex-1 md:flex-none md:px-4 p-2 rounded-lg font-semibold text-xs bg-white hover:bg-gray-100 text-black border border-black dark:bg-black dark:text-white dark:border-white dark:hover:bg-gray-900 transition-colors duration-200"
                    >
                      <div className="flex items-center justify-center space-x-2">
                        <Eye className="w-3.5 h-3.5" />
                        <span>Preview Data</span>
                      </div>
                    </button>
                  )}
                </div>
              </div>

              {/* Template Download */}
              <div className="mx-4 mb-4">
                <div className="bg-gray-50 dark:bg-gray-900/40 rounded-lg p-2.5 border border-gray-200 dark:border-gray-800">
                  <div className="flex items-center justify-between gap-2 flex-wrap">
                    <div className="flex items-center space-x-2.5">
                      <div className="p-1.5 bg-black dark:bg-white rounded-full shrink-0">
                        <FileText className="w-3.5 h-3.5 text-white dark:text-black" />
                      </div>
                      <div>
                        <h3 className="font-semibold text-black dark:text-white text-xs">Need a template?</h3>
                        <p className="text-xs text-gray-600 dark:text-gray-400">Download our pre-formatted CSV template</p>
                      </div>
                    </div>
                    <a
                      href="/sampleFile/ratecard 5.csv"
                      download="ratecard.csv"
                      className="px-3 py-1.5 bg-black hover:bg-gray-800 text-white dark:bg-white dark:text-black dark:hover:bg-gray-200 rounded-lg font-semibold text-xs transition-colors duration-200 flex items-center space-x-1.5"
                    >
                      <FiDownload className="w-3.5 h-3.5" />
                      <span>Download Template</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}